import { baseUrl } from "../airport/apis";

export const flightDealsUrl = `${baseUrl}/deal`;
export const loadDestinationsUrl = `${baseUrl}/flight/destinations`;
export const loadRoutesUrl = `${baseUrl}/flight/routes`;
export const cheapFlightsUrl = `${baseUrl}/flight/cheapflights`;
